module.exports = __webpack_public_path__ + "static/Guggenheim_Mobile-d432b1b180717416cfd6194db4aa0e66.jpg";